module.exports = __webpack_public_path__ + "img/pvc.e32a01a3.jpg";